<template>
  <v-container class="view" style="min-height:100vh">
    <v-row justify="center" align="center">
      <v-col cols="12" sm="4">
        <h2 class="text-capitalize  mt-0 ">Sign Up</h2>
        <p class="text--secondary mt-n1 mb-7 ">
          create an account to begin
        </p>
        <!------------------use dialog component to give off feedback to user if success or error ------------>
        <v-dialog transition="dialog-bottom-transition" max-width="300" v-model="dialog" class="d-none">
          <template v-slot:default="dialog">
            <v-card>
              <!----------------------show error or success modal--------------------->
              <v-toolbar :color="sign_up_error ? 'red' : 'success'" dark class="text-capitalize">
                <!--------------------if registration is successful, the dialog should be green with "success" as title else the dialog should be red with "error setting up account" as title ---------------->
                {{ !sign_up_error ? "Success!" : "Error setting up account!" }}
              </v-toolbar>
              <small class="text-small">
                <!-----------------destructure  server response here-------------------->
                <div class="text-h6 pa-12">
                  <!--show congratulations with success message or oops with error message-->
                  {{ !sign_up_error ? "Congratulations! " : "Oops! " }} <br />
                  <span v-html="message"></span>
                </div>
              </small>
              <v-card-actions class="justify-end">
                <v-btn text @click="dialog.value = false" :to="sign_up_error ? 'sign-up' : 'confirm-otp'">
                  <!--show okay or proceed to login-->
                  {{ sign_up_error ? "Okay" : "Okay" }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>

        <!--snackbar -->
        <v-snackbar v-model="snackbar" :color="sign_up_error ? 'red' : 'success'" class="text-capitalize" absolute
          right top>
          <!--------------------if registration is successful, the dialog should be green with "success" as title else the dialog should be red with "error setting up account" as title ---------------->
          {{ !sign_up_error ? "Account successfully created!" : "Error setting up account!" }}
          <template v-slot:action="{ attrs }">
            <v-btn  text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
        <!--snackbar end-->

        <v-form v-model="valid" @submit.prevent="submit" lazy-validation ref="form">
          <v-text-field v-model="firstname" :rules="name_rules" outlined label="First name" required
            placeholder="first name" class="text-capitalize"></v-text-field>

          <v-text-field v-model="lastname" :rules="name_rules" label="Last name" required placeholder="last name"
            class="text-capitalize" outlined></v-text-field>

          <v-text-field v-model="email" :rules="email_rules" label="E-mail" required placeholder="example@mailer.com"
            outlined></v-text-field>

          <v-text-field autocomplete="current-password" :value="userPassword" label="Password" outlined
            v-model="password" :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'" @click:append="() => (value = !value)"
            :type="value ? 'password' : 'text'" :rules="password_rules" @input="(_) => (userPassword = _)">
          </v-text-field>

          <v-btn block type="submit" class="mt-3 white--text" large :loading="loading" :disabled="loading"
            color="var(--purple)">
            Sign Up
          </v-btn>
          <small class="text-normal grey-text text-small pt-2 d-block mt-4">
            already have an account?
            <router-link :to="{ name: 'login' }">Login </router-link>
          </small>


        </v-form>
        <!--modal to return mail sent status-->
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import axios from "axios";
import store from "@/store";
export default {
  data: () => ({
    //valid_form: false,
    firstname: "",
    lastname: "",
    email: "",
    password: "",
    loading: false,
    loader: null,
    timeout: -1,
    response: {},
    message: "",
    dialog: false,
    snackbar: false,
    sign_up_error: false,
    password_rules: [
      (v) => v.length >= 8 || "Password must be at least 8 characters",
    ],

    name_rules: [(v) => !!v || "Name is required"],
    email_rules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+/.test(v) || "Invalid email address",
    ],
    userPassword: "",
    valid: true,
    value: true,
  }),

  methods: {
    async submit() {
      //get form inputs, validate the data  and send them only when valid to the server 
      const { firstname, lastname, email, password } = this
      if (!this.$refs.form.validate()) return;
      try {
        this.loading = true;
        const response = await axios.post("/auth/register/", {
          firstname, lastname, email, password,
        });
        //stop the loading action once theres a response  from the backend
        if (response) {this.loading = false}
        if (response.status !== 200) {
          //reset fields and send feed back
          this.message = response.data.message;
          this.dialog = true;
          this.response = response.data;
          this.sign_up_error = true;
          return
        }
        //inform the user of the status
        this.response = response.data;
        this.message = response.data.message;
        this.loading = false;
        this.dialog = true;
        this.sign_up_error = response.data.error;

        // destructure the response
        const { data } = response.data
        const { accessToken: token } = data

        //commit the access token to store and exit the function{
        store.dispatch("auth/set_otp_access_token", token);
        //route to the confirm otp screen
        this.$router.push({ name: "confirm-setup-otp" });
        return
      }
      catch (error) {
        //inform the user of the error message 
        this.loading = false;
        this.dialog = true;
        this.sign_up_error = true;
        this.message = error.response.data.message;
        this.response = error.response.data;
        return
      }
    },
  },
};
</script>


<style scoped>
h2+p {
  color: #7d7d7d;
  line-height: 36px;
  font-size: 17px;
}
</style>